import { NavigationGuard } from 'vue-router';
import store from '../../store';

export const loadProjectsGuard: NavigationGuard = async (to, from, next) => {
  await store.dispatch('project/loadItems');
  next();
};
